import ImageProductService from "@/services/ImageProductService";
import handleAlert from "@/utils/HandleAlert";
import {
  removeModeImage,
  removePage,
  setModeImage,
  setPage,
} from "@/utils/HandleToken";

export default {
  namespaced: true,
  state: {
    // SEARCH PRODUCT
    form: {
      descript : null
    },
    tempForm: {},

    limit: 20,
    imageFiles: [],

    search: {},
    datas: [],
    pagination: {},

    statusCheckedImage: false,
    tempCheckedImages: [],

    statusPreview: true,
    dataPreview: {},

    modeImageView: true, // FALSE === TABLE, TRUE === CARD

    searchAdd : {
      type: '1',
    },
    datasAdd: [],
    detailAdd : {},
  },
  mutations: {
    // SEARCH PRODUCT
    SET_FORM(state, value) {
      state.form = value;
    },
    SET_TEMPFORM(state, value){
      state.tempForm = value;
    },
    RESET_FORM(state) {
      state.form = {};
      state.tempForm = {};
    },

    // UPLOAD IMAGE PRODUCT
    SET_IMAGEFILES(state, value) {
      state.imageFiles.push(...value);
    },
    SPLICE_IMAGEFILES(state, value) {
      state.imageFiles.splice(value, 1);
    },
    RESET_IMAGEFILES(state) {
      state.imageFiles = [];
    },

    // SEARCH DATA LIST IMAGE UPLOADER
    SET_SEARCH(state, value) {
      state.search = value;
    },
    SET_DATAS(state, value) {
      state.datas = value;
    },
    SET_PAGINATION(state, value) {
      state.pagination = value;
    },

    // TEMP CHECKED IMAGE
    SET_STATUS_CHECKED_IMAGE(state) {
      state.statusCheckedImage = !state.statusCheckedImage;
      state.tempCheckedImages = [];
    },
    SET_TEMP_CHECKED_IMAGE(state, value) {
      state.tempCheckedImages = value;
    },

    // IMAGE PREVIEW
    SET_PREVIEW(state) {
      state.statusPreview = !state.statusPreview;
    },
    SET_DATA_PREVIEW(state, value) {
      state.dataPreview = value;
    },


    SET_STATUS(state, value) {
      state.search.status = value;
    },
    SET_MODEIMAGEVIEW(state, value) {
      state.modeImageView = value;
    },

    // LIST IMAGE EXISTING
    SET_SEARCH_ADD(state, value) {
      state.searchAdd = value;
    },
    SET_DATAS_ADD(state, value) {
      state.datasAdd = value;
    },
    SET_DETAIL_ADD(state, value) {
      state.detailAdd = value;
    },
    RESET_FORMADD(state) {
      state.searchAdd = {
        type: '1',
      };
      state.datasAdd = [];
      state.detailAdd = {};
    }
  },
  actions: {
    async searchProduct({commit, state, dispatch}) {
      try {
        state.form.type = "1";
        const result = await ImageProductService.searchIdemp(state.form);
        commit("SET_TEMPFORM", result.data[0]);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      } 
    },
    async uploadImages({ commit, state, dispatch, rootState }) {
      const formData = new FormData();
      const form = { ...state.form };

      form.compcode = rootState.Auth.userData.compcode;
      form.compname = rootState.Auth.userData.compname;
      form.ucreated = rootState.Auth.userData.fullname;
      formData.append("form", JSON.stringify(form));

      for (let i = 0; i < state.imageFiles.length; i++) {
        formData.append("files", state.imageFiles[i]);
      }

      try {
        const result = await ImageProductService.uploadImage(formData);
        handleAlert({ commit, dispatch }, result, null);
        if (result.meta.code === 201) {
          commit("SET_FORM", {});
          commit("RESET_IMAGEFILES");
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async readAll({ commit, state, dispatch, rootState }, payload) {
      removePage();
      if (!payload) {
        payload = 1;
      }
      const lastIndex = localStorage.getItem("lastMenuIndex");
      if (lastIndex) {
        state.search.status = lastIndex;
      }
      if (!state.search.compcode) {
        state.search.compcode = rootState.Auth.userData.compcode;
      }
      const form = {
        query: state.search,
        pagination: {
          limit: state.limit,
          page: payload,
        },
      };
      try {
        const result = await ImageProductService.findAll(form);
        commit("SET_DATAS", result.data.data);
        commit("SET_PAGINATION", result.data.pagination);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      } finally {
        setPage(payload);
      }
    },
    async delete({ commit, state, dispatch }, payload) {
      try {
        const { data, closeModal } = payload;
        const result = await ImageProductService.delete(data);
        handleAlert({ commit, dispatch }, result, null);
        if (result.meta.code == 201) {
          dispatch("readAll", state.pagination.currentPage);
          closeModal.click();
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async deleteAll({ commit, state, dispatch }, payload) {
      try {
        const { images, closeModal } = payload;
        const result = await ImageProductService.deleteAll(images);
        handleAlert({ commit, dispatch }, result, null);
        if (result.meta.code == 201) {
          commit("SET_STATUS_CHECKED_IMAGE");
          dispatch("readAll", state.pagination.currentPage);
          closeModal.click();
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    setModeImage({ commit }, payload) {
      removeModeImage();
      if (payload === null) {
        payload = true;
      }
      commit("SET_MODEIMAGEVIEW", payload);
      setModeImage(payload);
    },
    async searchIdemp({commit, state, dispatch, rootState}) {
      try {
        state.searchAdd.brand = rootState.Auth.userData.brand;
        const result = await ImageProductService.searchIdemp(state.searchAdd);
        commit("SET_DATAS_ADD", result.data);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      } 
    },
    async uploadImagesTwo({commit, state, dispatch, rootState}) {
      const formData = new FormData();
      const form = { ...state.detailAdd };
      form.compcode = rootState.Auth.userData.compcode;
      form.compname = rootState.Auth.userData.compname;
      form.ucreated = rootState.Auth.userData.fullname;
      formData.append("form", JSON.stringify(form));
      for (let i = 0; i < state.imageFiles.length; i++) {
        formData.append("files", state.imageFiles[i]);
      }
      try {
        const result = await ImageProductService.uploadImageTwo(formData);
        handleAlert({ commit, dispatch }, result, null);
        if (result.meta.code === 201) {
          commit("SET_DETAIL_ADD", {});
          commit("RESET_IMAGEFILES");
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    }
  },
  getters: {
    showListPrincipal: (state, getters, rootState) => {
      const allowedLevels = [1, 2]; // Tingkat yang diperbolehkan
      const userLevel = rootState.Auth.userData?.level; // Gunakan optional chaining
      return allowedLevels.includes(userLevel);
    }
  }
};
